import { singleton } from "tsyringe";

@singleton()
export class OperatingSystem {
  private operatingSystem: string | null = null;
  public getOperatingSystem(): string {
    if (this.operatingSystem !== null) {
      return this.operatingSystem;
    }

    const { userAgent } = window.navigator;

    this.operatingSystem = "unknown";
    if (userAgent.indexOf("Win") !== -1) {
      this.operatingSystem = "Windows";
    }
    if (userAgent.indexOf("Mac") !== -1) {
      this.operatingSystem = "OSX";
    }
    if (userAgent.indexOf("Linux") !== -1) {
      this.operatingSystem = "Linux";
    }
    if (userAgent.indexOf("Android") !== -1) {
      this.operatingSystem = "Android";
    }
    if (userAgent.indexOf("like Mac") !== -1) {
      this.operatingSystem = "iOS";
    }

    return this.operatingSystem;
  }
}
